module.exports = __webpack_public_path__ + "static/media/클래스프렙_이용안내서_학생.15406dfe.pdf";